var _circle, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBnpl(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 24,
    fill: "#1A1464"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10106_85401)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.9602 30.93L19.0802 28.08C18.9002 27.9 18.8102 27.69 18.8102 27.45C18.8102 27.21 18.9002 27 19.0802 26.82C19.2602 26.64 19.4702 26.55 19.7102 26.55C19.9502 26.55 20.1602 26.64 20.3402 26.82L22.5902 29.01L27.4802 24.12C27.6402 23.96 27.8452 23.88 28.0952 23.88C28.3452 23.88 28.5602 23.97 28.7402 24.15C28.9202 24.33 29.0102 24.54 29.0102 24.78C29.0102 25.02 28.9202 25.23 28.7402 25.41L23.2202 30.93C23.0402 31.11 22.8302 31.2 22.5902 31.2C22.3502 31.2 22.1402 31.11 21.9602 30.93ZM15.0002 36C14.5202 36 14.1002 35.82 13.7402 35.46C13.3802 35.1 13.2002 34.68 13.2002 34.2V15.6C13.2002 15.12 13.3802 14.7 13.7402 14.34C14.1002 13.98 14.5202 13.8 15.0002 13.8H16.9502V12.96C16.9502 12.7 17.0452 12.475 17.2352 12.285C17.4252 12.095 17.6502 12 17.9102 12C18.1902 12 18.4252 12.095 18.6152 12.285C18.8052 12.475 18.9002 12.7 18.9002 12.96V13.8H29.1002V12.96C29.1002 12.7 29.1952 12.475 29.3852 12.285C29.5752 12.095 29.8002 12 30.0602 12C30.3402 12 30.5752 12.095 30.7652 12.285C30.9552 12.475 31.0502 12.7 31.0502 12.96V13.8H33.0002C33.4802 13.8 33.9002 13.98 34.2602 14.34C34.6202 14.7 34.8002 15.12 34.8002 15.6V34.2C34.8002 34.68 34.6202 35.1 34.2602 35.46C33.9002 35.82 33.4802 36 33.0002 36H15.0002ZM15.0002 34.2H33.0002V21.3H15.0002V34.2Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10106_85401"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28.8,
    height: 28.8,
    fill: "white",
    transform: "translate(9.6001 9.59961)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBnpl);
export default __webpack_public_path__ + "static/media/bnpl.7f87c3d27e6d56bee78b06fa2a874009.svg";
export { ForwardRef as ReactComponent };